const Down = () => import(/* webpackChunkName:"chunk-download" */ '../views/P4_Page/Down')

// prettier-ignore
const Routes = [
  {
    path: '/download', name: 'download', component: Down
  },
  {
    path: '/echo-download', name: 'echo-download', component: Down
  }
]
export default Routes
